export default __webpack_public_path__ + "static/media/PHANISWAR_REDDY.59666600.jpeg";